$(document).ready(function(){
  
  $('.mobile-toggle').on('click', function(){
  	$('.mobile-menu').slideToggle();
  })
  
  
  $(window).resize(function() {

    var width = $(window).width();

    if (width >= 991){
      $('.mobile-menu').slideUp();
    }

  })
  
  
  $(window).scroll(function(){
    var header = $('header.header');
    var shopNavMobile = $('.shop-nav-mobile')
	
    if (scroll >= 100){
      header.addClass('fixed');
      shopNavMobile.addClass('fixed');
    } else {
     header.removeClass('fixed'); 
     shopNavMobile.removeClass('fixed');
    }

  });
  
  $('header.header .nav-bar .left-menu ul li.Shop').on('mouseenter', function(){
  	$(this).find('ul').fadeIn();
  })
  
  $('header.header .nav-bar .left-menu ul li.Shop .sub-menu').on('mouseleave', function(){
    $(this).fadeOut();
  })
  
  $('header.header .nav-bar .left-menu ul li.Cleanse').on('mouseenter', function(){
  	$('header.header .nav-bar .left-menu ul li.Shop .sub-menu').fadeOut();
  })
  
  $('header.header .nav-bar .left-menu ul li.About').on('mouseenter', function(){
    $('header.header .nav-bar .left-menu ul li.Shop .sub-menu').fadeOut();
  })
  
  $('.shop-nav-mobile .header').on('click', function(){
  	$('.shop-nav-mobile').find('ul').slideToggle();
    $(this).find('svg').toggleClass('fa-chevron-down fa-chevron-up');
  })
  
  $('.shop-nav-mobile ul li').on('click', function(){
  	$('.shop-nav-mobile ul').slideUp();
    $('.shop-nav-mobile .header svg').removeClass('fa-chevron-up');
    $('.shop-nav-mobile .header svg').addClass('fa-chevron-down');
    
  })

  // home slider
  $(".home-collections-slider").owlCarousel({
    items: 4,
    margin: 20,
    navigation : false,
    dots: false,
    loop: true,
    autoplay: true,
    autoplaySpeed: 500,
    responsive:{
      0: {
        items: 2
      },
      575: {
        items: 2
      },
      768: {
        items: 3
      },
      1280: {
        items: 4
      }
    }
  });
  
  // best sellers slider
    $(".best-seller-slider").owlCarousel({
    items: 5,
    margin: 30,
    navigation : false,
    dots: false,
    loop: true,
    autoplay: true,
    autoplaySpeed: 500,
    responsive:{
      0: {
        items: 2,
      },
      575: {
        items: 2
      },
      768: {
        items: 3
      },
      1280: {
        items: 5
      }
    }
  });
  
  // sticky header 
  $(window).scroll(function () {
    var header = $(".shop-nav");
    scroll = $(window).scrollTop();
    
    if (scroll >= 100){
      header.addClass('fixed');
    } else {
      header.removeClass('fixed');
    }
  });
  
  // locations
  $('.locations-container').find('ul li').first().addClass('active');
  $('.locations .location').first().addClass('active');
  
  var previousActiveTabIndex = 0;
  
  $('.locations-container ul li').on('click', function(){
    var index = $(this).data('tab');
  	$('.locations-container ul li').removeClass('active');
    $('.locations .location').each(function(){
      if( $('.locations .location').data('tab') == index ){
      	console.log('truuuu')
      }
    })
    $(this).addClass('active')
  })
  
})
